import { useEffect, useRef, useState } from "react";
import { AdminService } from "../utils";
import { useAsync } from "../../../utils/hooks/useAsync";
import "./UploadImage.scss";
import { toast } from "react-toastify";
import { Icon } from "../../Icon";
import Label from "../../Label";
import useDevice from "../../../utils/hooks/useDevice";
import classNames from "classnames";

type param = {
  product: Product;
  urlImage: string;
};

const UploadImage = (param: param) => {
  const { product, urlImage } = param;
  const { run } = useAsync();
  const { isMobile } = useDevice();
  const [images, setImages] = useState<string[]>(
    urlImage ? urlImage.split("|") : []
  );
  const [main, setMain] = useState<string>();
  const [image, setImage] = useState<FormData>();
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setMain(images[0]);
  }, []);
  useEffect(() => {
    image && saveImage();
  }, [image]);
  const changeHandler = async (event: any) => {
    const file = event.currentTarget.files[0];
    const data = new FormData();
    data.append("image", file);
    product._id && data.append("_id", product._id);
    data.append("thumbnailUrl", images.join("|"));
    setImage(data);
  };

  const saveImage = () => {
    toast.warning("Subiendo la imagen");
    image &&
      run(AdminService.saveImage(image)).then((r: any) => {
        toast.success("Imagen guardada");

        setImages(r.newUrl.split("|"));
      });
  };

  const handleMain = (e: any) => {
    setMain(e.currentTarget.id);
    let aux = images.filter((el) => el != e.currentTarget.id);
    aux.unshift(e.currentTarget.id);
    setImages(aux);
    run(
      AdminService.updateProduct({ ...product, thumbnailUrl: aux.join("|") })
    );
  };

  const handleDelete = (imageDelete: string) => {
    const filtredImages = images.filter((el) => el != imageDelete);
    const newThumbnailUrl = filtredImages.join("|");
    var image = imageDelete.slice(29);
    run(
      AdminService.deleteImage({
        image,
        thumbnailUrl: newThumbnailUrl,
        _id: product._id,
      })
    ).then((r: any) => {
      toast.success("Imagen borrada");
      setImages(filtredImages);
      setMain(filtredImages[0]);
    });
  };
  const handleClick = (e: any) => {
    if (ref.current !== null) {
      ref.current.click();
    }
  };
  return (
    <div className="uploadImage_Container">
      <div className="uploadImageHeader">
        <Label
          tag="h3"
          style={{
            textAlign: "left",
            fontFamily: "Mont-Semibold",
            fontSize: isMobile ? "16px" : "18px",
          }}
        >
          Imágenes
        </Label>
      </div>
      <div className="uploadImageExisting">
        {images.map((img) => {
          return (
            <div className="uploadImageImage" key={img}>
              <img src={img} className="imgThumbnail"></img>
              <div className="uploadImageControls">
                {img === main ? (
                  <div className="uploadImageChecked">
                    <Icon
                      iconName="check_icon"
                      className="uploadImageChecked__icon"
                    ></Icon>
                  </div>
                ) : (
                  <>
                    <p
                      className="uploadImageCheck"
                      id={img}
                      onClick={handleMain}
                    />
                  </>
                )}
                <div onClick={() => handleDelete(img)}>
                  <Icon iconName="trash_cart" className="uploadImageButton" />
                </div>
              </div>
            </div>
          );
        })}
        <div className="uploadImage">
          <input
            type="file"
            name="file"
            ref={ref}
            onChange={changeHandler}
            style={{ display: "none" }}
          />

          <button
            type="button"
            onClick={handleClick}
            className={classNames("uploadImage__button", {
              "uploadImage__button--mobile": isMobile,
            })}
          >
            Subir imagen
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
